import { ActionIcon, Button, Popover } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import clsx from 'clsx';
import { useState } from 'react';
import { AddOperationMenu } from './AddOperationMenu';

const ICON_SIZE = 15;

export function AddStepContentPopover({
  testContentId,
  insertAfterStepOrder,
  insertAfterStepIndex,
  onClose,
  isLastStep,
  disabled,
  activePageAlias,
}: {
  testContentId: string;
  insertAfterStepOrder: number;
  insertAfterStepIndex?: number;
  onClose?: () => void;
  isLastStep?: boolean;
  disabled?: boolean;
  activePageAlias?: string;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Popover
      shadow="md"
      width={375}
      position="bottom"
      withArrow
      trapFocus
      opened={isMenuOpen}
      onChange={setIsMenuOpen}
      disabled={disabled}
      middlewares={{ size: true }}
      styles={{
        dropdown: {
          overflow: 'hidden',
        },
      }}
    >
      <Popover.Target>
        {isLastStep ?
          <Button
            className="mt-6"
            title="Add Step"
            size="compact-sm"
            disabled={disabled}
            variant="light"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            leftSection={<IconPlus size={ICON_SIZE} />}
            data-testid="add-step-at-end-button"
          >
            Add Step
          </Button>
        : <div
            style={{ zIndex: 1000 }}
            className={clsx(
              'absolute flex w-full -translate-y-1/2 justify-center opacity-0 transition-all delay-75 hover:opacity-100',
              {
                'opacity-100': isMenuOpen,
              },
            )}
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            <ActionIcon
              title="Add Step"
              // onClick={() => setIsMenuOpen((prev) => !prev)}
              radius="xl"
              size={24}
              disabled={disabled}
              className="flex items-center justify-center bg-gray-700 hover:bg-gray-800 dark:bg-gray-700 dark:hover:bg-gray-500"
            >
              <IconPlus size={14} />
            </ActionIcon>
          </div>
        }
      </Popover.Target>
      <Popover.Dropdown className="px-2 py-4">
        <AddOperationMenu
          testContentId={testContentId}
          insertAfterStepOrder={insertAfterStepOrder}
          insertAfterStepIndex={insertAfterStepIndex}
          onClose={onClose}
          closePopover={() => setIsMenuOpen(false)}
          activePageAlias={activePageAlias}
        />
      </Popover.Dropdown>
    </Popover>
  );
}
